import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Hidden } from 'components/Base';
import { formatPercent } from 'utils';
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    width: '100%'
  },
  color: {
    minWidth: '0px',
    borderRadius: '2px',
    height: '20px'
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0',
    justifyContent: 'space-between'
  },
  name: {
    margin: '2px 0'
  },
  valueBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '4rem',
    fontWeight: 500
  },
  colorBox: {
    width: '20px',
    height: '20px',
    minWidth: '20px',
    minHeight: '20px',
    maxHeight: '20px',
    marginRight: '8px;',
    borderRadius: '50%'
  },
  itemBox: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  big: {
    fontSize: '20px'
  }
});
const Legend = ({ data, isForFactSheet = false }: any) => {
  const theme = useTheme() as any;
  const classes = useStyles();
  const isData = data && data.length > 0;

  const dataToRender = isData
    ? data
    : ['Hidden text', 'Hidden text', 'Hidden text'];

  return (
    <div className={classes.container}>
      {dataToRender.map((legend: any, index: number) => {
        return (
          <Hidden
            key={`${legend.name}-${index}`}
            isHidden={!isData}
            margin="5px 0"
          >
            <div
              className={`${classes.box} ${isForFactSheet ? classes.big : ''}`}
            >
              <div className={classes.itemBox}>
                <div
                  className={classes.colorBox}
                  style={{
                    backgroundColor:
                      theme.palette.baseColors.charts['asset-allocation'][index]
                  }}
                />
                <span className={classes.name}>{legend.name}</span>
              </div>
              <div className={classes.valueBox}>
                <span>{formatPercent(legend.value)}</span>
              </div>
            </div>
          </Hidden>
        );
      })}
    </div>
  );
};

export default Legend;
